import { useContext as l } from "react";
import { H as e } from "../__utils-fc7746f4.js";
import { jsx as m } from "react/jsx-runtime";
function v(t) {
  let {
    level: n,
    children: o
  } = t;
  const r = l(e), i = Math.max(Math.min(n || r + 1, 6), 1);
  return /* @__PURE__ */ m(e.Provider, {
    value: i,
    children: o
  });
}
export {
  v as HeadingLevel
};
//# sourceMappingURL=heading-level.js.map
